"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Sidebar = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    root: {
      padding: spacing(3)
    },
    navigation: {
      padding: spacing(2, 0)
    },
    subTitle: {
      fontWeight: 'bold',
      fontSize: 12,
      textTransform: 'uppercase'
    },
    avatar: {
      width: 36,
      height: 36,
      marginRight: spacing(2)
    }
  };
});
/**
 * @typedef SidebarItem
 * @property {string} path
 * @property {function (): React.ReactNode} render
 * @property {boolean} disabled
 */

/**
 * Sidebar.
 *
 * @function
 * @param {object} props
 * @param {string} [props.avatarUrl='']
 * @param {string} [props.userName='']
 * @param {Array<SidebarItem>} props.items
 * @param {string} props.baseUrl
 * @param {boolean} [props.renderUserInfo=true]
 * @returns {React.Element}
 * @example
 * // TODO: Write example.
 */

var Sidebar = function Sidebar(_ref2) {
  var avatarUrl = _ref2.avatarUrl,
      userName = _ref2.userName,
      items = _ref2.items,
      baseUrl = _ref2.baseUrl,
      renderUserInfo = _ref2.renderUserInfo;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    className: classes.root
  }, renderUserInfo && /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_material.Avatar, {
    className: classes.avatar,
    alt: "Profile Picture",
    src: avatarUrl
  }), /*#__PURE__*/_react["default"].createElement(_material.Grid, null, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "subtitle2",
    className: classes.subTitle
  }, "Logged in as"), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2"
  }, userName))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    className: classes.navigation
  }, items.map(function (_ref3) {
    var path = _ref3.path,
        render = _ref3.render,
        disabled = _ref3.disabled;
    return !disabled && /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
      key: path,
      path: "".concat(baseUrl, "/").concat(path),
      render: render
    });
  })));
};

exports.Sidebar = Sidebar;
Sidebar.propTypes = {
  avatarUrl: _propTypes["default"].string,
  userName: _propTypes["default"].string,
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    path: _propTypes["default"].string.isRequired,
    render: _propTypes["default"].func.isRequired,
    disabled: _propTypes["default"].bool
  })).isRequired,
  baseUrl: _propTypes["default"].string.isRequired,
  renderUserInfo: _propTypes["default"].bool
};
Sidebar.defaultProps = {
  renderUserInfo: true,
  userName: '',
  avatarUrl: ''
};
var _default = Sidebar;
exports["default"] = _default;